/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-padding-bottom',
  templateUrl: './theme-option-datalabels-padding-bottom.component.html',
  styleUrls: ['./theme-option-datalabels-padding-bottom.component.css']
})
export class ThemeOptionDatalabelsPaddingBottomComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  color = ItemColor('themes');
  showDetails: boolean;
  optionType: ThemeOptionType = 'datalabels_padding_bottom';

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setDatalabels(this.optionType, value, this.datalabelsIndex, type ? [type] : undefined);
  }

}
